import { render, staticRenderFns } from "./AkamaiTable.vue?vue&type=template&id=39cc43db&scoped=true&"
import script from "./AkamaiTable.vue?vue&type=script&lang=js&"
export * from "./AkamaiTable.vue?vue&type=script&lang=js&"
import style0 from "./AkamaiTable.vue?vue&type=style&index=0&id=39cc43db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cc43db",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCheckbox,VIcon,VSimpleTable})
